import { render } from "./DemandesList.vue?vue&type=template&id=bbf16f64&ts=true"
import script from "./DemandesList.vue?vue&type=script&lang=ts"
export * from "./DemandesList.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__